import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { ApiOptions } from '../Models/ApiOptions.model';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(
    private http: HttpClient,
    private cookieService: CookieService
  ) { }

  public getAuthHeader(): string | null{
    let token: string | null;
    token = sessionStorage.getItem('access_token');
    if (token) {
        return `Bearer ${token}`;
    }
    token = this.cookieService.get('access_token');
    if (token) {
        return `Bearer ${token}`;
    }
    return '';
  }

  get(url: string, options: ApiOptions = {}): Observable<any> {
    if (this.confirmNetworkConnection()) {
      const opts = this.setOptions(options);
      return this.http.get(url, opts);
    } else {
      this.networkAlert();
      return of();
    }
  }

  post(url: string, data = {}, options: ApiOptions = {}): Observable<any> {
    if (this.confirmNetworkConnection()) {
      const opts = this.setOptions(options);
      return this.http.post(url, data, opts);
    } else {
      this.networkAlert();
      return of();
    }
  }

  put(url: string, data = {}, options: ApiOptions = {}): Observable<any> {
    if (this.confirmNetworkConnection()) {
      const opts = this.setOptions(options);
      return this.http.put(url, data, opts);
    } else {
      this.networkAlert();
      return of();
    }
  }

  patch(url: string, data = {}, options: ApiOptions = {}): Observable<any> {
    if (this.confirmNetworkConnection()) {
      const patchOptions = {
        ...options,
        headers: options.headers instanceof HttpHeaders
          ? options.headers.set('Content-Type', 'application/merge-patch+json')
          : { ...options.headers, 'Content-Type': 'application/merge-patch+json' }
      };
      const opts = this.setOptions(patchOptions);
      return this.http.patch(url, data, opts);
    } else {
      this.networkAlert();
      return of();
    }
  }

  remove(url: string, options: ApiOptions = {}): Observable<any> {
    if (this.confirmNetworkConnection()) {
      const opts = this.setOptions(options);
      return this.http.delete(url, opts);
    } else {
      this.networkAlert();
      return of();
    }
  }

  private setOptions(item: ApiOptions): any {
    return {
      headers: this.getHeadersWithAuth(item),
      params: item.params
    };
  }

  private getHeaders(headers: Record<string, string> = {}): HttpHeaders {
    const defaultHeaders = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      ...headers
    };
    return new HttpHeaders(defaultHeaders);
  }

  private getHeadersWithAuth(item: ApiOptions): HttpHeaders {
    const baseHeaders = item.headers instanceof HttpHeaders 
      ? item.headers 
      : this.getHeaders(item.headers as Record<string, string>);
    
    const token = this.getAuthHeader();
    if (token) {
      return baseHeaders.set('Reef-Auth-Type', 'oauth')
                       .set('Authorization', token);
    }
    return baseHeaders;
  }

  private networkAlert(): void {
    alert('ERROR: There is a problem with your network connection.');
  }

  private confirmNetworkConnection(): boolean {
    return navigator.onLine;
  }
}
